import React from 'react';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';

import StyledLink from '../Link';

// Definindo o tipo para as props da SubAba
interface SubAbaProps {
  $isActive: boolean;
}

// Definindo o tipo para as props do componente BarraSubAbas
interface BarraSubAbasProps {
  subAbas: Array<{
    label: string;
    rota: string;
  }>;
}

const ContainerBarraSubAbas = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.barraSubAbas.fundo};
  font-size: 0.85rem;
`;

const SubAba = styled.div<SubAbaProps>`
  font-weight: normal;
  height: 100%;
  padding: 0px 10px 0px 10px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.barraSubAbas.fonte};
  &:hover {
    border-bottom: 2px solid ${({ theme }) => theme.colors.barraSubAbas.fonte};
    cursor: pointer;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      border-bottom: 2px solid ${({ theme }) => theme.colors.barraSubAbas.barra};
    `}
`;

// Ajustando o componente para receber e mapear as SubAbas
const BarraSubAbas: React.FC<BarraSubAbasProps> = ({ subAbas }) => {
  const location = useLocation();

  return (
    <ContainerBarraSubAbas>
      {subAbas.map((subAba, index) => {
        // Determina se a aba está ativa
        const isActive = location.pathname === subAba.rota;

        return (
          <StyledLink
            key={index}
            to={subAba.rota}
            style={{ textDecoration: 'none' }}
          >
            <SubAba $isActive={isActive}>{subAba.label}</SubAba>
          </StyledLink>
        );
      })}
    </ContainerBarraSubAbas>
  );
};

export default BarraSubAbas;
